import React from 'react';
import RiskRadiobuttonContainer from './RiskRadioButtonContainer';
import styles from '../styles/Activity.module.scss';

type Props = {
  header: string;
  value: string;
  setValue?: (value: string) => void;
  naValue?: boolean;
  edmsNo?: boolean;
  text?: string;
  setText?: (text: string) => void;
  placeholder?: string;
  name: string;
  disabled?: boolean;
};

const RiskRadiobuttonSection = ({
  header,
  value,
  setValue,
  edmsNo,
  text,
  setText,
  placeholder,
  name,
  disabled,
}: Props) => (
  <div className={styles.oneCard}>
    <RiskRadiobuttonContainer
      header={header}
      value={value}
      setValue={setValue}
      edmsNo={edmsNo}
      text={text}
      setText={setText}
      placeholder={placeholder}
      name={name}
      disabled={disabled}
    />
  </div>
);

export default RiskRadiobuttonSection;
